<template>
  <v-card :style="backOpacity">
    <v-card-title>{{ title }} SelectForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ returnData }} -->
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
            <v-col cols="3">
              <set-css
                :params="String(returnData.css)"
                v-on:set="$set(returnData, 'css', $event)"
              ></set-css>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="初期値"
                v-model="returnData.init"
                required
              ></v-text-field>
            </v-col>
            rulesの長さ:{{ rules.length }}
          </v-row>
          <v-row>
            <p>バリデーション</p>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[4]"
                label="×ボタン"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[5]"
                label="空値不可"
                value="required"
              ></v-checkbox
            ></v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[20]"
                label="全角のみ"
                value="fullWidth"
              ></v-checkbox
            ></v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[18]"
                :label="
                  rules[18] == 'true'
                    ? '入力不可'
                    : rules[18] == '3'
                    ? '新規作成時のみ入力可'
                    : '入力不可'
                "
                :value="
                  rules[18] == 'true' ? '' : rules[18] == '' ? '3' : 'true'
                "
                :on-icon="
                  rules[18] == 'true'
                    ? 'mdi-checkbox-marked'
                    : rules[18] == '3'
                    ? 'mdi-close-box-outline'
                    : 'mdi-checkbox-blank-outline'
                "
                :off-icon="
                  rules[18] == 'true'
                    ? 'mdi-checkbox-marked'
                    : rules[18] == '3'
                    ? 'mdi-close-box-outline'
                    : 'mdi-checkbox-blank-outline'
                "
              ></v-checkbox>
            </v-col>

            <v-col cols="3">
              <v-checkbox
                v-model="rules[17]"
                label="複数選択可"
                value="true"
              ></v-checkbox
            ></v-col>
          </v-row>
          rules:{{ rules }}
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                v-model="returnData.form_check"
                label="特定フォーム一覧"
              ></v-checkbox>
            </v-col>
            <v-col v-if="returnData.form_check" cols="2">
              <search-Page
                label="フォームID"
                v-model="rules[0]"
                required
              ></search-Page>
            </v-col>
            <v-col v-if="returnData.form_check" cols="3">
              <v-select
                label="ソート順"
                v-model="sort"
                item-text="label"
                item-value="value"
                :items="sortRule"
              ></v-select>
            </v-col>
          </v-row>
          <!-- -->
          <v-row>
            <v-col v-if="!returnData.form_check" cols="12">
              <v-text-field
                label="選択肢 カンマ(,)区切り"
                v-model="con_selectbox"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="returnData.form_check">
            <v-col cols="3">
              <v-checkbox
                v-model="linkType"
                label="セレクトボックス連動"
                :disabled="linkType != null && linkType != 'selectboxlink'"
                value="selectboxlink"
              ></v-checkbox>
            </v-col>
            <v-col col="3">
              <v-checkbox
                v-model="linkType"
                label="条件連動"
                :disabled="linkType != null && linkType != 'conditionLink'"
                value="conditionLink"
              ></v-checkbox>
            </v-col>
            <v-col col="3">
              <v-checkbox
                v-model="linkType"
                label="同一ページの選択肢から絞り込む"
                :disabled="linkType != null && linkType != 'searchlink'"
                value="searchlink"
              ></v-checkbox>
            </v-col>
          </v-row>
          <!-- -->
          <v-row v-if="linkType == 'selectboxlink'">
            <v-col cols="2">
              <search-Page
                label="連動元フォームID"
                v-model="rules[1]"
                hint="同一ページ"
                samePage
              ></search-Page>
            </v-col>
            <v-col cols="2">
              <search-Page
                label="絞り込み条件フォームID"
                v-model="rules[3]"
                :hint="'絞り込み対象のフォームID'"
              ></search-Page>
            </v-col>
            <v-col v-if="linkType == 'selectboxlink'" class="mt-3">
              ※モーダルサブページを用いて、検索候補を絞り込む際に使用
            </v-col>
          </v-row>
          <!-- -->
          <v-row v-if="linkType == 'conditionLink'">
            <v-col col="3">
              <search-Page
                label="絞り込み対象reportのフォームID"
                v-model="rules[1]"
              ></search-Page>
            </v-col>
            <v-col col="3">
              <search-Page
                label="ページID"
                v-model="rules[2]"
                searchPage
              ></search-Page>
            </v-col>
            <v-col col="3">
              <search-Page
                label="セレクト対象となるフォームID"
                v-model="rules[3]"
              ></search-Page>
            </v-col>
          </v-row>
          <!-- -->
          <div v-if="linkType == 'searchlink'">
            <v-col class="mt-3">
              <v-btn @click="searchlinkAdd" class="ma-2">追加</v-btn>
              <v-btn @click="searchlinkDel" class="ma-2">削除</v-btn>
              ※絞り込み検索を行いセレクトボックスの候補を減らす<br />
            </v-col>
            <div v-for="(val, i) in values1" :key="`1-${i}`">
              <v-row>
                <v-col cols="2"></v-col>
                <v-col cols="2">
                  <search-Page
                    label="連動元フォームID"
                    v-model="values1[i]"
                    hint="同一ページ"
                    samePage
                  ></search-Page>
                </v-col>
                <v-col cols="3">
                  <search-Page
                    label="絞り込み条件フォームID"
                    v-model="values3[i]"
                    hint="[特定フォーム一覧]のフォームIDと同じページ"
                  ></search-Page>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- -->
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                v-model="freeInput"
                label="特定条件でテキスト入力"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="freeInput">
              <v-text-field
                label="IF条件フォームID"
                v-model="rules[6]"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-if="freeInput">
              <v-text-field
                label="if == X(コロン[:]区切り)"
                v-model="rules[7]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                v-model="rules[12]"
                label="選択した値を特定のテキストフォームに代入"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules[12]">
              <v-text-field
                label="ページ内のサブページformID"
                v-model="rules[13]"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-if="rules[12]">
              <v-text-field
                label="対象サブページ内にある代入先テキストフォームformID"
                v-model="rules[14]"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-col cols="3" class="ml-0">
            <v-checkbox
              v-model="rules22Flag"
              label="切り替え時特定フォームに値代入"
            ></v-checkbox>
          </v-col>

          <div v-for="(set, index) in rules22set" :key="index">
            <v-row>
              <v-col cols="2" v-if="rules22Flag">
                <v-text-field
                  label="自身の値がxの時"
                  v-model="set.myValue"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules22Flag">
                <v-text-field
                  label="対象formID"
                  v-model="set.targetID"
                  :rules="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="rules22Flag">
                <v-text-field
                  label="代入する値"
                  v-model="set.addValue"
                  :rules="[]"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-btn v-if="rules22Flag" @click="onAddRules22" color="primary"
            >追加
          </v-btn>
          <v-btn v-if="rules22Flag" @click="onDelRules22" color="red"
            >削除
          </v-btn>
          <v-row>
            <v-col cols="auto">
              <v-checkbox
                v-model="rules[9]"
                label="サブページに自身の要素をコピー"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules[9]">
              <v-text-field
                label="ページ内のサブページformID"
                v-model="rules[10]"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-if="rules[9]">
              <v-text-field
                label="対象サブページ内にあるコピー先セレクトフォームformID"
                v-model="rules[11]"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                v-model="rules[8]"
                label="自身を非表示"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rules15Flag"
                label="初期値として対象フォームに代入"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules15Flag">
              <v-text-field
                label="保存先フォームID"
                v-model="rules[15]"
                :rules="[varidation.numANDcolon]"
              ></v-text-field
              >*マスタデータへ保存時は最低2個必要(id:0で回避)</v-col
            >
            <v-col cols="4" v-if="rules15Flag">
              <v-checkbox
                v-model="rules16Flag"
                label="自身と[連動元フォームID*1]で算出される値"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rules16Flag">
              <v-text-field
                label="デフォルト値となるフォームID"
                v-model="rules[16]"
                :rules="[varidation.numonly]"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules[19]"
                label="セレクトボックスをクリック選択式表示に変更"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[19] == 'true'">
              <v-checkbox
                v-model="rules[25]"
                label="順番を超えた場合色を変える"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules[19] == 'true'">
              <v-checkbox
                v-model="rules[26]"
                label="先頭に番号を追加"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-checkbox
                v-model="rules[21]"
                label="予測変換機能"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules24Flag"
                label="特定条件で入力可"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules24Flag">
              <v-select
                label="判定値"
                v-model="rules24Mode"
                :rules="[$store.state.validation.required]"
                item-text="label"
                item-value="value"
                :items="disabledRule"
              ></v-select>
            </v-col>
            <v-col cols="3" v-if="rules24Flag && rules24Mode == 'role'">
              <v-select
                label="XXの時入力可"
                v-model="rules24Term"
                :rules="[$store.state.validation.required]"
                item-text="label"
                item-value="value"
                :items="disabledRoleRule"
              ></v-select>
            </v-col>
            <v-col cols="3" v-if="rules24Flag && rules24Mode == 'formID'">
              <v-text-field
                label="IF条件フォームID"
                v-model="rules24targetID"
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
            <v-col cols="3" v-if="rules24Flag && rules24Mode == 'formID'">
              <v-text-field
                label="if == X"
                hint="先頭に「!」を付けると条件式が!=になります。"
                v-model="rules24Word"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rules27Flag"
                label="サブページの特定フォームを選択肢に追加"
              ></v-checkbox>
            </v-col>
            <v-col cols="3" v-if="rules27Flag">
              <search-Page
                label="サブページformID"
                v-model="rules27Sub"
                hint="同一ページ"
                samePage
              ></search-Page>
            </v-col>
            <v-col cols="3" v-if="rules27Flag">
              <search-Page
                label="対象formID"
                v-model="rules27target"
                hint="別ページ"
              ></search-Page>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import searchPage from "./common/searchPage.vue";
import setCols from "./common/setCols.vue";
import setCss from "../CSSparam/setCssParam.vue";

export default {
  components: {
    searchPage,
    setCols,
    setCss,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    css: { type: String, default: "" },
    //個別値
    init: String,
    selectbox: Array,
    form_check: Boolean,
    rule: String, //検索対象のform_idはruleに格納する
  },
  data() {
    return {
      title: "セレクトフォーム",
      backOpacity: "opacity: 1",
      showButton: false,
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        css: this.css,
        //個別値
        init: this.init,
        selectbox: this.selectbox,
        form_check: false,
        rule: this.rule,
      },
      searchView: false,
      colView: false,
      rules: [0, 0],
      con_selectbox: "",
      linkType: null,
      //
      freeInput: false,
      values1: [],
      values3: [],
      rules15Flag: false,
      rules16Flag: false,
      rules22Flag: false,
      rules22set: [],
      rules22myValue: "",
      rules22targetID: "",
      rules22addValue: "",
      rules24Flag: false,
      rules24Mode: "",
      rules24Term: "",
      rules24targetID: "",
      rules24Word: "",
      rules27Flag: false,
      rules27Sub: "",
      rules27target: "",
      sort: "jp",
      sortRule: [
        { label: "日本語順(ABC⇒漢字)", value: "jp" },
        { label: "日本語順(漢字⇒ABC)", value: "revjp" },
        { label: "作成(降順)", value: "old" },
        { label: "作成(昇順)", value: "new" },
        { label: "数→数英 順(1,2,3,1a,1b)", value: "numalp" },
      ],
      disabledRule: [{ label: "権限", value: "role" }, { label: "フォームID", value: "formID" }],
      disabledRoleRule: [
        //disabledはtrueで入力不可なのでvalueの条件が逆
        { label: "管理者のみ可", value: "!= 1" },
        { label: "管理者以外可", value: "== 1" },
        { label: "一般のみ可", value: "!= 0" },
        { label: "一般以外可", value: "== 0" },
      ],

      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numANDcolon: (value) => {
          return /^[0-9:]*$/.test(value) || "数値のみ";
        },

        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);
    if (this.type == 30) {
      this.title = "メール送信対象";
    }
    this.con_selectbox = this.selectbox.join(",");
    if (
      typeof this.rule != "undefined" &&
      this.rule != null &&
      this.rule != "0"
    ) {
      this.rules = this.rule.split(",");
    }
    //
    if (this.rules[0] != null && this.rules[0] != "" && this.rules[0] != 0) {
      this.returnData.form_check = true;
      this.sort = this.selectbox.join(",");
      //
      if (typeof this.rules[23] != "undefined" && this.rules[23] != "") {
        this.linkType = this.rules[23];
        if (this.linkType == "searchlink") {
          this.values1 = this.rules[1].split(".");
          this.values3 = this.rules[3].split(".");
        }
      } else if (
        this.rules[0] != 0 &&
        this.rules[1] != 0 &&
        this.rules[2] != 0
      ) {
        this.linkType = "conditionLink";
      } else if (this.rules[0] != 0 && this.rules[1] != 0) {
        this.linkType = "selectboxlink";
      }
    }

    //
    if (this.nullCheck(this.rules[6])) {
      this.freeInput = true;
    }
    if (this.nullCheck(this.rules[15])) {
      this.rules15Flag = "true";
    }
    if (this.nullCheck(this.rules[16])) {
      this.rules16Flag = "true";
    }
    if (typeof this.rules[22] != "undefined" && this.rules[22] != "") {
      this.rules22Flag = true;
      const tmpset = this.rules[22].split("^");
      for (let i = 0; i < tmpset.length; i++) {
        let tmp = { myValue: "", targetID: "", addValue: "" };
        [tmp.myValue, tmp.targetID, tmp.addValue] = tmpset[i].split(".");
        this.rules22set.push(tmp);
      }
    } else {
      let tmp = { myValue: "", targetID: "", addValue: "" };
      this.rules22set.push(tmp);
    }
    if (this.nullCheck(this.rules[24])) {
      this.rules24Flag = true;
      const tmp = this.rules[24].split("|");
      if (tmp.length < 3) {
        this.rules24Mode = tmp[0];
        this.rules24Term = tmp[1];
      } else {
        this.rules24Mode = tmp[0];
        this.rules24targetID = tmp[1];
        this.rules24Word = tmp[2];
      }
      
    }
    if (this.nullCheck(this.rules[27])) {
      this.rules27Flag = true;
      const tmp = this.rules[27].split("|");
      this.rules27Sub = tmp[0];
      this.rules27target = tmp[1];
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (
          this.linkType != "selectboxlink" &&
          this.linkType != "conditionLink" &&
          this.linkType != "searchlink"
        ) {
          this.rules[1] = null;
          this.rules[2] = null;
          this.rules[3] = null;
          this.rules[23] = null;
        } else {
          this.rules[23] = this.linkType;
          if (this.linkType == "searchlink") {
            this.rules[1] = this.values1.join(".");
            this.rules[3] = this.values3.join(".");
          }
        }
        if (this.linkType != "conditionLink") {
          this.rules[2] = null;
        }
        if (!this.freeInput) {
          this.rules[6] = null;
          this.rules[7] = null;
        }
        if (this.rules15Flag == null) {
          this.rules[15] = null;
          this.rules[16] = null;
        }
        if (this.rules16Flag == null) {
          this.rules[16] = null;
        }
        if (this.rules22Flag) {
          this.rules[22] = "";
          for (let i = 0; i < this.rules22set.length; i++) {
            this.rules[22] +=
              this.rules22set[i].myValue +
              "." +
              this.rules22set[i].targetID +
              "." +
              this.rules22set[i].addValue;

            if (i + 1 != this.rules22set.length) this.rules[22] += "^";
          }
        } else {
          this.rules[22] = "";
        }
        if (this.rules24Flag) {
          if (this.rules24Mode == 'role') {
            this.rules[24] = this.rules24Mode + "|" + this.rules24Term;
          } else if (this.rules24Mode == 'formID') {
            this.rules[24] = this.rules24Mode + "|" + this.rules24targetID + "|" + this.rules24Word;
          }
        } else {
          this.rules[24] = "";
        }
        if (this.rules27Flag) {
          this.rules[27] = this.rules27Sub + "|" + this.rules27target;
        } else {
          this.rules[27] = "";
        }
        if (this.rules[19] != "true") {
          this.rules[25] = "";
          this.rules[26] = "";
        }
        //
        if (
          this.returnData.form_check == "true" ||
          this.returnData.form_check == true
        ) {
          this.returnData.selectbox = this.sort.split(",");
        } else {
          this.rules[0] = null;
          this.returnData.selectbox = this.con_selectbox.split(",");
        }
        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
    searchlinkAdd() {
      this.values1.push(this.values1[this.values1.length - 1]);
      this.values3.push(this.values3[this.values3.length - 1]);
    },
    searchlinkDel() {
      if (this.values1.length > 0) {
        this.values1.pop();
        this.values3.pop();
      }
    },
    onAddRules22() {
      const lastElement = this.rules22set[this.rules22set.length - 1];
      this.rules22set.push(JSON.parse(JSON.stringify(lastElement)));
    },
    onDelRules22() {
      if (this.rules22set.length == 1) return;

      this.rules22set.pop();
    },
  },
};
</script>
